import React from 'react';

const Link = ({ label, properties }, key) => (
    <a key={key} className="nav-link" {...properties}>
        {label}
    </a>
);
const Links = _ => (
    <nav className="nav nav-masthead justify-content-center">
        {[
            {
                label: 'Accueil',
                properties: {
                    href: 'https://micetf.fr',
                    title: 'MiCetF (Accueil)',
                },
            },
            {
                label: 'Lignes graduées',
                properties: {
                    className: 'nav-link active',
                },
            },
            {
                label: 'Contact',
                properties: {
                    href:
                        'mailto:webmaster@micetf.fr&subject=Au sujet de /graduations/',
                    title: 'Pour contacter le webmaster...',
                },
            },
            {
                label: 'Télécharger',
                properties: {
                    href: '../usb?zip=graduations.zip',
                    title:
                        'Télécharger une version portable de cette application web.',
                    className: 'btn btn-info btn-dl',
                },
            },
        ].map((p, k) => Link(p, k))}
    </nav>
);

export default () => (
    <header className="masthead mb-auto">
        <div className="inner">
            <h3 className="masthead-brand" title="Des Outils Pour La Classe">
                MiCetF
            </h3>
            <Links />
        </div>
    </header>
);
